<app-action-modal
  #actionModal
  [disabled]="submitted"
  [showHeader]="true"
  headerIconState="error"
  size="md"
  (submitted)="confirm()"
>
  <app-trash-icon
    height="16px"
    width="16px"
    color="var(--error-600)"
    headerIcon
  />
  <ng-container mainTitle i18n>Annuler la résiliation</ng-container>
  <ng-container subtitle i18n
    >Cette demande n'aboutira pas. Pour quelle raison ?</ng-container
  >
  <div class="cancellation-cancel-modal__body" body>
    <div class="cancellation-cancel-modal__options">
      @for (option of reasons; track option) {
        <label class="cancellation-cancel-modal__option">
          <input
            type="radio"
            class="cancellation-cancel-modal__radio"
            name="cancellation-cancel-reason"
            [value]="option"
            [formControl]="reason"
          />
          <span>{{ getCancellationCancelReasonLabel(option) }}</span>
        </label>
      }
    </div>
    @if (confirmTried && !reason.value) {
      <div class="invalid mt-8" i18n>Veuillez choisir une raison.</div>
    }
  </div>
  <ng-container submitButtonLabel i18n>Annuler la résiliation</ng-container>
</app-action-modal>
